// Delegation also supports sections reloaded in Shopify's theme editor.
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-cgr-scroll]');
  if (!button) return;
  const rail = document.getElementById(button.getAttribute('aria-controls'));
  if (!rail) return;
  rail.scrollBy({ left: Number(button.dataset.cgrScroll) * rail.clientWidth * 0.85,
    behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
});
// Shrine's Escape path closes <details> without resetting its overlay/ARIA state.
document.addEventListener('toggle', (event) => {
  if (!event.target.matches('header-drawer details, menu-drawer details')) return;
  event.target.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(event.target.open));
}, true);

// Keep each navigation's disclosures exclusive and expose their current state.
document.addEventListener('toggle', (event) => {
  const menu = event.target;
  if (!menu.matches('.cgr-nav--mobile .cgr-menu')) return;
  menu.querySelector('summary').setAttribute('aria-expanded', String(menu.open));
  if (menu.open) menu.parentElement.querySelectorAll('.cgr-menu[open]').forEach((other) => {
    if (other !== menu) other.open = false;
  });
}, true);
function rrSetMenu(menu, open) {
  menu.classList.toggle('is-open', open);
  menu.querySelector('.cgr-menu__trigger').setAttribute('aria-expanded', String(open));
  menu.querySelector('.cgr-nav__menu').inert = !open;
  if (open) menu.parentElement.querySelectorAll('.cgr-menu.is-open').forEach((other) => {
    if (other !== menu) rrSetMenu(other, false);
  });
}
document.addEventListener('pointerover', (event) => {
  const menu = event.target.closest('.cgr-nav--desktop .cgr-menu');
  if (menu && !menu.contains(event.relatedTarget) && matchMedia('(hover:hover)').matches) rrSetMenu(menu, true);
});
document.addEventListener('pointerout', (event) => {
  const nav = event.target.closest('.cgr-nav--desktop');
  if (nav && !nav.contains(event.relatedTarget)) nav.querySelectorAll('.cgr-menu.is-open').forEach((menu) => rrSetMenu(menu, false));
});
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('.cgr-menu__trigger');
  // With a mouse, hover has already opened the menu; a toggle here would shut it mid-animation.
  if (trigger) rrSetMenu(trigger.parentElement, matchMedia('(hover:hover)').matches || !trigger.parentElement.classList.contains('is-open'));
  document.querySelectorAll('.cgr-nav--desktop .cgr-menu.is-open').forEach((menu) => {
    if (!menu.contains(event.target) || event.target.closest('a')) rrSetMenu(menu, false);
  });
});
document.addEventListener('focusout', (event) => {
  const menu = event.target.closest('.cgr-nav--desktop .cgr-menu');
  if (menu && !menu.contains(event.relatedTarget)) rrSetMenu(menu, false);
});
// Shrine's drawer expects nested subpages; these mobile panels are inline accordions.
document.addEventListener('click', (event) => {
  const summary = event.target.closest('.cgr-nav--mobile .cgr-menu > summary');
  if (!summary) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  summary.parentElement.open = !summary.parentElement.open;
}, true);
document.addEventListener('keydown', (event) => {
  const menu = event.target.closest('.cgr-nav--mobile .cgr-menu[open]');
  if (event.key !== 'Escape' || !menu) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  menu.open = false;
  menu.querySelector('summary').focus();
}, true);
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.cgr-nav--desktop .cgr-menu.is-open').forEach((menu) => {
    if (menu.contains(document.activeElement)) menu.querySelector('.cgr-menu__trigger').focus();
    rrSetMenu(menu, false);
  });
  document.querySelectorAll('.cgr-localization[open]').forEach((menu) => {
    menu.open = false;
    menu.querySelector('summary').focus();
  });
});
document.addEventListener('click', (event) => {
  document.querySelectorAll('.cgr-localization[open]').forEach((menu) => {
    if (!menu.contains(event.target)) menu.open = false;
  });
});
let runitFavorites = [];
try {
  const saved = JSON.parse(localStorage.getItem('runit:favorites') || '[]');
  if (Array.isArray(saved)) runitFavorites = saved.filter((handle) => typeof handle === 'string');
} catch { /* Favourites remain usable in memory when storage is unavailable. */ }
class RunItFavorite extends HTMLElement {
  connectedCallback() {
    const button = this.querySelector('button');
    if (!button) return;
    this.refresh();
    button.onclick = () => {
      const handle = this.dataset.handle;
      runitFavorites = runitFavorites.includes(handle)
        ? runitFavorites.filter((item) => item !== handle) : [...runitFavorites, handle];
      try { localStorage.setItem('runit:favorites', JSON.stringify(runitFavorites)); } catch { /* Memory fallback. */ }
      document.querySelectorAll('runit-favorite').forEach((item) => item.refresh());
    };
  }
  refresh() {
    this.querySelector('button')?.setAttribute('aria-pressed', String(runitFavorites.includes(this.dataset.handle)));
  }
}
if (!customElements.get('runit-favorite')) customElements.define('runit-favorite', RunItFavorite);

// Search without changing the market; choosing a country submits Shopify's form.
document.addEventListener('input', (event) => {
  if (!event.target.matches('.cgr-country-search')) return;
  const form = event.target.form;
  const query = event.target.value.trim().toLocaleLowerCase();
  const countries = [...form.querySelectorAll('.cgr-country-list button[name="country_code"]')];
  countries.forEach((button) => { button.hidden = !button.textContent.toLocaleLowerCase().includes(query); });
  form.querySelector('.cgr-country-empty').hidden = countries.some((button) => !button.hidden);
});
document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!form.matches('.cgr-localization form')) return;
  if (!event.submitter?.matches('button[name="country_code"]') || form.getAttribute('aria-busy') === 'true') {
    event.preventDefault();
    return;
  }
  form.setAttribute('aria-busy', 'true');
  form.querySelector('.cgr-localization__status').hidden = false;
});
window.addEventListener('pageshow', () => {
  document.querySelectorAll('.cgr-localization form[aria-busy]').forEach((form) => {
    form.removeAttribute('aria-busy');
    form.querySelector('.cgr-localization__status').hidden = true;
  });
});

// Enter in search must not implicitly submit the first (possibly hidden) country.
document.addEventListener('keydown', (event) => {
  if (event.key === 'Enter' && event.target.matches('.cgr-country-search')) event.preventDefault();
});
